import {TypeCategory} from '../../core/model/type-category.model';

export interface TypeCategoryState {
  typeCategory: Array<TypeCategory> | null;
}

export const intializeTypeCategoryState = function(){
  return [];
};
